var map = {
	"./evolution100.json": [
		"iJOp",
		10
	],
	"./evolution200.json": [
		"5hat",
		9
	],
	"./evolution300.json": [
		"45oC",
		8
	],
	"./global.json": [
		"W3Zz"
	],
	"./loads.json": [
		"vUlr"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "lHSK";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/config lazy ^\.\/.*\.json$
// module id = lHSK
// module chunks = 12